module.exports = __webpack_public_path__ + "img/umbrella-03.cf13c312.svg";